import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NumericCellEditorComponent} from './numeric-cell-editor/numeric-cell-editor.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {InputNumberModule} from 'primeng/inputnumber';
import { CustomHeaderComponent } from './custom-header/custom-header.component';

@NgModule({
  declarations: [
    NumericCellEditorComponent,
    CustomHeaderComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    InputNumberModule
  ],
})
export class AgGridModule { }
